import React, { useEffect, useState } from 'react';

import Select from 'react-select';
import axios from 'axios';

const OrderForm = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowInputState, setRowInputState] = useState({});
  const [campaignName, setCampaignName] = useState('');

  const [filters, setFilters] = useState({
    Region: '',
    Retailer: '',
    Media: '',
    Cataegeory: '',
    'Assest Element Type': '',
    Location: '',
    Doors: ''
  });
  useEffect(() => {
    axios.get('https://stores.comart.in:5000/stores')
      .then(response => setData(response.data))
      .catch(err => console.error('Failed to fetch data:', err));
  }, []);

// Helper to extract Job No from a row
const getJobNoFromItem = (item) => {
  return (
    item['Job No'] ||   // Excel-style key
    item.JobNo ||       // PascalCase
    item.jobNo ||       // camelCase
    ''                  // fallback
  );
};

  useEffect(() => {
    const result = data.filter(item =>
      Object.entries(filters).every(([key, value]) => {
        if (!value) return true;
        const itemValue = item[key];
        return typeof itemValue === 'string' &&
          itemValue.toLowerCase() === value.toLowerCase();
      })
    );
    setFilteredData(result);
    setSelectedRows([]);
    setRowInputState({});
  }, [filters, data]);

  const getOptions = (key) => {
    const values = Array.from(new Set(data.map(item => item[key]).filter(Boolean)));
    return values.map(v => ({ label: v, value: v }));
  };

  const toggleSelection = (item) => {
    const isSelected = selectedRows.includes(item);
    if (isSelected) {
      setSelectedRows(prev => prev.filter(row => row !== item));
      setRowInputState(prev => {
        const newState = { ...prev };
        delete newState[item._id || item.id || JSON.stringify(item)];
        return newState;
      });
    } else {
      setSelectedRows(prev => [...prev, item]);
    }
  };

  const isChecked = (item) => selectedRows.includes(item);

  const toggleSelectAll = () => {
    if (selectedRows.length === filteredData.length) {
      setSelectedRows([]);
      setRowInputState({});
    } else {
      setSelectedRows(filteredData);
    }
  };

  const isAllSelected = filteredData.length > 0 && selectedRows.length === filteredData.length;

  const allColumns = Object.keys(data[0] || {});
  const customInputs = ['Instructions', 'Image URL'];

  const handleInputChange = (id, field, value) => {
    setRowInputState(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value
      }
    }));
  };

const placeOrder = async () => {
  if (!campaignName.trim()) {
    alert("Please enter a Campaign Name");
    return;
  }

  const lineItems = selectedRows.map(item => {
    const id = item._id || item.id || JSON.stringify(item);
    const jobNo = getJobNoFromItem(item);

    return {
      ...item,
      Instructions: rowInputState[id]?.Instructions || '',
      ImageURL: rowInputState[id]?.['Image URL'] || '',
         pdfUrl: jobNo
        ? `http://kerp.comart.in:3008/api/pdf/job/${jobNo}`
        : null
    };
  });

  const finalOrder = {
    campaignName,
    createdAt: new Date().toISOString(),
    totalItems: lineItems.length,
    items: lineItems,
    implementImage: [],
    status: "Yet to Start"
  };

  try {
    const response = await fetch('https://stores.comart.in:3001/api/save-order', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(finalOrder)
    });

    const result = await response.json();

    if (response.ok) {
      console.log('[Order Saved]', result);
      setCampaignName('');
      setSelectedRows([]);
      setRowInputState({});
    } else {
      console.error(result);
    }
  } catch (err) {
    console.error('❌ Error saving order:', err);
  }
};



  return (
    <div style={{ padding: '20px' }}>
      <h3 style={{ marginBottom: '20px' }}>Filter Orders from Store Data</h3>

      {/* Filter Section */}
      <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
        {Object.keys(filters).map(key => (
          <div key={key} style={{ width: '200px' }}>
            <Select
              options={getOptions(key)}
              placeholder={`Filter by ${key}`}
              isClearable
              value={filters[key] ? { label: filters[key], value: filters[key] } : null}
              onChange={(selected) =>
                setFilters(prev => ({
                  ...prev,
                  [key]: selected ? selected.value : ''
                }))
              }
            />
          </div>
        ))}
        <button
          onClick={() =>
            setFilters(Object.fromEntries(Object.keys(filters).map(k => [k, ''])))
          }
          style={{
            padding: '6px 14px',
            backgroundColor: '#dc3545',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontWeight: 'bold',
            height: '40px',
            alignSelf: 'center'
          }}
        >
          Clear All
        </button>
      </div>

      {/* Campaign Input */}
      <div style={{ marginBottom: '20px', width: '300px' }}>
        <input
          type="text"
          placeholder="Enter Campaign Name"
          value={campaignName}
          onChange={(e) => setCampaignName(e.target.value)}
          style={{
            width: '100%',
            padding: '8px',
            fontSize: '14px',
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
        />
      </div>

      {/* Table Header */}
      <h4>
        Filtered Store Orders ({selectedRows.length} selected)
        <button
          onClick={toggleSelectAll}
          style={{
            marginLeft: '20px',
            padding: '6px 12px',
            backgroundColor: isAllSelected ? '#ffc107' : '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          {isAllSelected ? 'Deselect All' : 'Select All'}
        </button>
      </h4>

      {/* Table */}
   <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '500px', marginTop: '10px', border: '1px solid #ccc' }}>
  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
    <thead>
      <tr style={{ backgroundColor: '#e9ecef', position: 'sticky', top: 0, zIndex: 1 }}>
        <th style={thStyle}>
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={toggleSelectAll}
          />
        </th>
        {allColumns.map(col => (
          <th key={col} style={thStyle}>{col}</th>
        ))}
        {customInputs.map(field => (
          <th key={field} style={thStyle}>{field}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {filteredData.length === 0 ? (
        <tr>
          <td colSpan={allColumns.length + customInputs.length + 1} style={{ textAlign: 'center', padding: '10px' }}>
            No matching records
          </td>
        </tr>
      ) : (
        filteredData.map((item, idx) => {
          const id = item._id || item.id || JSON.stringify(item);
          return (
            <tr key={idx}>
              <td style={tdStyle}>
                <input
                  type="checkbox"
                  checked={isChecked(item)}
                  onChange={() => toggleSelection(item)}
                />
              </td>
              {allColumns.map(col => (
                <td key={col} style={tdStyle}>{item[col]}</td>
              ))}
              {customInputs.map(field => (
                <td key={field} style={tdStyle}>
                  {isChecked(item) && (
                    <input
                      type="text"
                      placeholder={field}
                      value={rowInputState[id]?.[field] || ''}
                      onChange={(e) => handleInputChange(id, field, e.target.value)}
                      style={{ width: '150px' }}
                    />
                  )}
                </td>
              ))}
            </tr>
          );
        })
      )}
    </tbody>
  </table>
</div>


      {/* Place Order Button */}
      {selectedRows.length > 0 && (
        <div style={{ marginTop: '20px', textAlign: 'center' }}>
          <button
            onClick={placeOrder}
            style={{
              padding: '10px 20px',
              backgroundColor: '#28a745',
              color: '#fff',
              border: 'none',
              borderRadius: '6px',
              fontWeight: 'bold',
              cursor: 'pointer'
            }}
          >
            Place Order
          </button>
        </div>
      )}
    </div>
  );
};

const thStyle = {
  padding: '8px',
  border: '1px solid #ccc',
  fontWeight: 'bold',
  textAlign: 'left',
  whiteSpace: 'nowrap'
};

const tdStyle = {
  padding: '6px',
  border: '1px solid #eee',
  whiteSpace: 'nowrap'
};

export default OrderForm;
